export default "__VITE_PUBLIC_ASSET__afba1a9a__"